export * from './bewertungs-anlasss.page';
export * from './bewertungs-anlasss.page.resolver';
